import ApplyGiftCardSFC from "./ApplyGiftCard.vue";
export const ApplyGiftCard = ApplyGiftCardSFC;
